<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.deliverer && notificationTypes">
  <app-popup-header title="{{localService.languageContent.deliverer.header}}"></app-popup-header>
  <div *ngIf="localService.isServiceProviderBlocked()" style="margin: 10px;">
    {{localService.languageContent.deliverer.suspended}}
  </div>
  <div *ngIf="!localService.isServiceProviderBlocked()">
    <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row">
        <div class="col-4">
          <input autocomplete="off" type="number" class="number"
            (keypress)="localService.isNumberOnly($event,numericConfig)"
            min="1" [ngClass]="wrapper.source.content.v6 ? 'en' : ''" [(ngModel)]="wrapper.source.content.v6"
            placeholder="*{{localService.languageContent.deliverer.contact_num}}"
            title="*{{localService.languageContent.deliverer.contact_num}}" id="{{elementIds.ph_num}}" />
        </div>
        <div class="col-8">
          <input autocomplete="off" type="email" [ngClass]="wrapper.source.content.v7 ? 'en' : ''"
            [(ngModel)]="wrapper.source.content.v7" placeholder="*{{localService.languageContent.deliverer.email}}"
            title="*{{localService.languageContent.deliverer.email}}" id="{{elementIds.email}}" />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label style="font-weight: normal; margin-left: 30px;">
            <input type="checkbox" [(ngModel)]="isActive" [disabled]="true" />
            <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
          </label>
        </div>
        <div class="col-sm-6">
          <label style="font-weight: normal; margin-left: 30px;">
            <input type="checkbox" [(ngModel)]="isAvailableNow" />
            <span class="normal_color">{{localService.languageContent.deliverer.is_available}}</span>
          </label>
        </div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-sm-12">
          <label style="font-weight: normal; margin-left: 30px;">
            <input type="checkbox" [(ngModel)]="isPrivate" />
            <span class="normal_color">{{localService.languageContent.deliverer.is_private}}</span>
          </label>
        </div>
      </div>
      <div class="row" *ngIf="!localService.isHideDummy">
        <div class="col-sm-12">
          <div style="float:left;width:50px;">
            <i style="margin-left:15px;" class="material-icons button icon_adjust">business</i>
          </div>
          <div style="float:left;width:calc(100% - 100px)">
            <span *ngIf="wrapper.myBusiness.length == 0">{{localService.languageContent.deliverer.no_business}}</span>
            <ngx-select [noAutoComplete]="true" *ngIf="wrapper.myBusiness.length > 0" [items]="wrapper.myBusiness"
              [optionValueField]="'key'" [optionTextField]="'v1'" [(ngModel)]="wrapper.source.content.v5"
              [allowClear]="true">
              <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                <div title="{{option.data.v1}}" [ngClass]="localService.getLanguageCode(option.data.v2)">
                  <span>{{option.data.v1}}</span>
                </div>
              </ng-template>
            </ngx-select>
          </div>
          <div style="float:left;width:50px;">
            <button style="color:#008CBA;margin-left:10px;" class="button_icon button_icon_color "
              [disabled]="wrapper.source.content.v1 != localService.selected.user"
              (click)="onAddBusiness()">add_circle_outline</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <app-label [Text]="localService.languageContent.common.upi"></app-label>
        </div>
        <div class="col-8">
          <input autocomplete="off" [ngClass]="wrapper.source.content.v8 != '' ? 'en' : ''" type="text"
            [(ngModel)]="wrapper.source.content.v8" placeholder="{{localService.languageContent.common.upi}}"
            title="{{localService.languageContent.common.upi}}" />
        </div>
      </div>
      <app-language-container [MaxLength]="100" [IsNeedNewLine]="true"
        [(languageContents)]="wrapper.source.languageContents"
        (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,1)"
        [Title]="localService.languageContent.deliverer.service_types" [MandatoryLanguages]="mandatoryLanguages"
        [IsPartiallyMandatory]="true" [id]="elementIds.name"></app-language-container>
      <div class="row">
        <div class="col-12">
          <div class="dropdown_div">
            <app-label [Text]="localService.languageContent.deliverer.notification_type"
              [IsNeedNewLine]="true"></app-label>
            <i class="material-icons icon_adjust" style="top:6px;"
              *ngIf="id != '' && wrapper.notificationTypes && wrapper.notificationTypes.length > 0"
              (click)="onOpenSmsSettings()">settings</i>
          </div>
          <div class="select_dropdown">
            <ngx-select [items]="notificationTypes" [optionValueField]="'key'" [optionTextField]="'value'"
              [multiple]="true" placeholder="{{localService.languageContent.deliverer.select_notification_type}}"
              [(ngModel)]="wrapper.notificationTypes" [noAutoComplete]="true">
            </ngx-select>
          </div>
        </div>
      </div>
      <app-language-container [MaxLength]="300" [(languageContents)]="wrapper.languageAddress"
        (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,2)"
        [Title]="localService.languageContent.deliverer.service_address" [MandatoryLanguages]="mandatoryLanguages"
        [IsLargeText]="true" [isModeChangeAllowed]="false"></app-language-container>
      <app-working-hours-range [workingRangeType]="workingRangeType" [selectedRange]="wrapper.source.range"
        (onRangeUpdated)="onRangeUpdate($event)"></app-working-hours-range>
    </div>
    <div class="modal-footer modal_footer_message" *ngIf="message != ''">
      <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
    </div>
    <div class="modal-footer">
      <div class="row" style="width: 100%;">
        <div class="col-6">
          <button type="button" class="btn btn-primary" *ngIf="id != ''" (click)="onDelete()"
            style="background-color:red !important;">{{localService.languageContent.common.delete}}</button>
        </div>
        <div class="col-6" style="text-align: right;">
          <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{ id == '' ?
            localService.languageContent.common.create : localService.languageContent.common.save}}</button>
        </div>
      </div>
    </div>
  </div>
</div>